module.exports = __webpack_public_path__ + "img/advancedEda.eabb6f6f.png";